/**
 * File: heading-title.js
 *
 * Import and initialize functions for Heading Titles.
 */

export default {
  headingTitle: document.querySelector('.elementor-heading-title'),
  init() {
    if (this.headingTitle) {
      this.render();
    }
  },
  render() {
    const headingTitles = document.querySelectorAll('.elementor-heading-title');
    headingTitles.forEach(title => {
      title.parentNode.setAttribute('tabindex', 0);
    })
  },
};
